import snapdocsClosing from './snapdocsClosing.reducer';

const reducer = {
  snapdocsClosing,
};

export default reducer;
